import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-and-faq',
  templateUrl: './help-and-faq.component.html',
  styleUrls: ['./help-and-faq.component.scss']
})
export class HelpAndFaqComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
